import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TokenService } from '../services/token.service';

export const authenticationGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);

  let idToken = tokenService.getIdToken();
  let accessToken = tokenService.getaccessToken();
  let areTokensExpired = tokenService.areTokensExpired();

  const login = localStorage.getItem('login');

  if (!login) {
    return true;
  } else {
    if (idToken && accessToken && !areTokensExpired) {
      return true;
    } else {
      tokenService.login();

      return false;
    }
  }
};
